const basestyle = ()=>({
    wrapper:{
        margin:'auto',
        maxWidth:'99%',
        width:'100%',
        padding:'0 0',
    }
})
export default basestyle;